var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 7.33331H3.33333C2.59695 7.33331 2 7.93027 2 8.66665V13.3333C2 14.0697 2.59695 14.6666 3.33333 14.6666H12.6667C13.403 14.6666 14 14.0697 14 13.3333V8.66665C14 7.93027 13.403 7.33331 12.6667 7.33331Z",
    stroke: "#646464",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 7.33331V4.66665C4.66602 3.78259 5.01721 2.93475 5.64233 2.30962C6.26745 1.6845 7.11529 1.33331 7.99935 1.33331C8.8834 1.33331 9.73125 1.6845 10.3564 2.30962C10.9815 2.93475 11.3327 3.78259 11.3327 4.66665V7.33331",
    stroke: "#646464",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjY2NjcgNy4zMzMzMUgzLjMzMzMzQzIuNTk2OTUgNy4zMzMzMSAyIDcuOTMwMjcgMiA4LjY2NjY1VjEzLjMzMzNDMiAxNC4wNjk3IDIuNTk2OTUgMTQuNjY2NiAzLjMzMzMzIDE0LjY2NjZIMTIuNjY2N0MxMy40MDMgMTQuNjY2NiAxNCAxNC4wNjk3IDE0IDEzLjMzMzNWOC42NjY2NUMxNCA3LjkzMDI3IDEzLjQwMyA3LjMzMzMxIDEyLjY2NjcgNy4zMzMzMVoiIHN0cm9rZT0iIzY0NjQ2NCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQuNjY2MDIgNy4zMzMzMVY0LjY2NjY1QzQuNjY2MDIgMy43ODI1OSA1LjAxNzIxIDIuOTM0NzUgNS42NDIzMyAyLjMwOTYyQzYuMjY3NDUgMS42ODQ1IDcuMTE1MjkgMS4zMzMzMSA3Ljk5OTM1IDEuMzMzMzFDOC44ODM0IDEuMzMzMzEgOS43MzEyNSAxLjY4NDUgMTAuMzU2NCAyLjMwOTYyQzEwLjk4MTUgMi45MzQ3NSAxMS4zMzI3IDMuNzgyNTkgMTEuMzMyNyA0LjY2NjY1VjcuMzMzMzEiIHN0cm9rZT0iIzY0NjQ2NCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };